module.exports = __webpack_public_path__ + "static/media/checked.94f24974.svg";